import HttpService from "./HttpService";
const API_ENDPOINT = "/profile-percentage";

const ProfilePercentageService = {
  async fetchPercentage() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default ProfilePercentageService;
